<template>
  <ContractEditorCore
    mode="subcontract"
    :non-editable-component="nonEditableComponent"
    :editor-component="editorComponent"
    :show-start-date="true"
    :show-payment-validation="false"
    :is-subcontract="true"
    :parent-contract-id-getter="parentContractIdGetter"
    :responsable-from-state="'subcontract'"
    :document-label="'Subcontrato'"
    @open-cost-breakdown-modal="openCostBreakdownModal"
  >
    </ContractEditorCore>
</template>

<script>
import ContractEditorCore from './ContractEditorCore.vue'
import NonEditableSubcontract from './NonEditableSubcontract.vue'
import SubcontractEditor from '@/components/Helpers/Editor/SubcontractEditor'
export default {
  name: 'SubcontractDetail',
  components: { ContractEditorCore },
  data() {
    return {
      nonEditableComponent: NonEditableSubcontract,
      editorComponent:      SubcontractEditor,
    }
  },
  methods: {
    parentContractIdGetter(contract) {
      return contract?.subcontract_to_contract_id
    },
    openCostBreakdownModal() {
      this.$store.commit('costbreakdown/setCostBreakdownSubcontractTablesModal', true)
    },
  },
}
</script>